import React from 'react'
import mb from './photolic/moneyback.jpg'
import './image.css'
const Moneyback = () => {
  return (
    <div>
      <img src={mb} alt="" className='eimg'/>
    </div>
  )
}

export default Moneyback
